import type { TOnboardingHubEntryPoint } from "@features/analytics";

export const ONBOARDING_HUB_PATH = "/pages/onboarding";

/** Navigate options telling the hub's view event where the user came from. */
export const hubEntry = (entryPoint: TOnboardingHubEntryPoint) => ({
  state: { entryPoint },
});
export const DASHBOARD_PATH = "/pages/home";

/** Credits UI is built but hidden until balances actually exist for accounts. */
export const CREDITS_ENABLED = false;

/** Made-for-you and onboarding decks are held back until the templates and the deck are final. */
export const ONBOARDING_DECKS_ENABLED = false;
